<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useNetworkStore } from '@/stores/network/store'

const i18n = useI18n()

const networkStore = useNetworkStore()

const errorMessage = computed(() =>
  networkStore.errorObject?.response?.status === 401
    ? i18n.t('notifications.errorCode.tokenExpired', { code: 401 })
    : networkStore.errorObject?.response?.data?.message ??
      networkStore.errorObject?.response?.data?.error ??
      (networkStore.errorObject?.response
        ? i18n.t('notifications.errorCode.requestFailed', {
            status: networkStore.errorObject.response.status,
          })
        : i18n.t('notifications.generalError'))
)

function reload() {
  window.location.reload()
}
</script>

<template>
  <div class="absolute inset-0 flex flex-col justify-center items-center">
    <h3 class="eb-heading mb-8">
      {{ errorMessage }}
    </h3>
    <button
      class="eb-legacy-button eb-legacy-button--md eb-legacy-button--primary"
      @click="reload()"
    >
      <!-- redo -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        class="eb-icon"
      >
        <path
          d="M500 8h-27.711c-6.739 0-12.157 5.548-11.997 12.286l2.347 98.568C418.075 51.834 341.788 7.73 255.207 8.001 118.82 8.428 7.787 120.009 8 256.396 8.214 393.181 119.165 504 256 504c63.926 0 122.202-24.187 166.178-63.908 5.113-4.618 5.354-12.561.482-17.433l-19.738-19.738c-4.498-4.498-11.753-4.785-16.501-.552C351.787 433.246 306.105 452 256 452c-108.322 0-196-87.662-196-196 0-108.322 87.662-196 196-196 79.545 0 147.941 47.282 178.675 115.302l-126.389-3.009c-6.737-.16-12.286 5.257-12.286 11.997V212c0 6.627 5.373 12 12 12h192c6.627 0 12-5.373 12-12V20c0-6.627-5.373-12-12-12z"
        />
      </svg>
      {{ $t('notifications.reload') }}
    </button>
  </div>
</template>
